var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWolf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M312.103,561.869c-0,0 -20.427,32.085 -17.215,44.705c1.23,4.831 8.048,3.255 13.262,-0.966c1.845,-1.493 9.661,-5.445 10.54,-7.202c-0,0 4.655,45.232 12.383,62.27c7.729,17.039 14.404,22.572 16.776,23.012c2.371,0.439 16.652,6.89 33.638,-9.135c4.655,-4.391 3.601,-3.337 8.08,-9.046c0,0 3.225,63.561 24.667,100.656c21.443,37.096 36.882,59.396 76.336,68.188c39.454,8.791 68.83,9.005 64.113,-18.87c-4.717,-27.875 -9.649,-36.738 -32.164,-51.39c0,-0 37.739,6.79 58.109,29.733c20.371,22.944 22.515,33.022 40.956,37.953c18.44,4.932 15.009,-9.434 12.651,-16.296c-2.359,-6.861 -2.788,-8.791 -4.718,-12.865c0,-0 13.08,6.004 18.012,23.801c4.932,17.797 2.144,41.384 -0.214,49.961c-2.359,8.577 -15.525,45.623 -19.084,51.462c-1.355,2.223 -9.327,14.583 -9.769,15.662",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.462,943.502c-0,0 -33.739,-48.95 -63.893,-63.608c-30.153,-14.658 -100.93,-36.855 -124.383,-69.94c-23.453,-33.085 -29.316,-39.786 -36.017,-53.606c0,-0 7.957,55.7 13.82,67.008c0,-0 -90.879,-33.923 -104.281,-132.341c0,0 -10.888,4.607 -13.82,12.145c0,0 -2.08,-13.366 -0.225,-23.371c-0,0 -7.701,0.555 -6.352,52.782c0,-0 -21.389,-1.855 -24.236,-75.171c-0.858,-22.086 7.719,-40.45 11.364,-50.03c0,-0 -10.721,2.856 -24.873,-0.146c0,0 20.799,-13.796 36.238,-50.604",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.323,506.217c-0,0 43.313,30.878 67.758,30.663c-0,0 -6.433,-9.006 -5.575,-15.224c-0,0 55.536,13.938 63.255,15.01c0,-0 -22.085,-74.191 -10.721,-103.353c0,-0 -13.737,36.225 -11.579,70.76c1.716,27.447 -43.314,3.86 -55.75,-5.36c-0,-0 3.859,13.749 0.857,20.598c-3.002,6.848 -45.029,-10.306 -48.245,-13.094Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.239,287.833c-0,0 13.434,-30.865 31.442,-40.752c8.959,-4.919 19.323,-17.039 23.187,-23.538c0,-0 -12.647,27.139 -17.302,39.435c-4.655,12.296 -26.612,35.658 -28.105,36.712c-0,0 1.142,-10.715 5.182,-20.376c4.04,-9.661 6.323,-19.849 9.661,-24.329c3.337,-4.479 4.83,-6.148 7.377,-7.904",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.303,86.657c0,-0 -18.128,11.031 -26.419,9.274c-8.291,-1.756 -22.695,-4.005 -20.446,-11.382c2.248,-7.378 14.834,-28.138 22.343,-30.284c0.984,-0.281 7.659,-3.091 13.35,-0.281c5.692,2.811 13.421,16.793 13.28,21.22c-0.141,4.426 -1.476,8.291 -1.827,9.134c-0.351,0.843 -0.281,2.319 -0.281,2.319Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.202,86.043c0,0 -24.675,34.543 -28.243,44.698c-3.568,10.155 -24.539,53.281 -40.406,74.08c-15.867,20.799 -29.947,9.149 -70.76,38.596c-16.94,12.223 -16.511,52.749 -17.369,61.326c0,0 8.003,-4.776 11.433,-9.707c0,-0 -7.788,41.442 3.577,55.38c-0,-0 8.363,-23.587 16.296,-30.449c0,0 -14.052,13.125 -15.919,19.053c0,0 -2.086,-29.971 1.977,-52.368c-0,0 -9.662,5.27 -11.528,7.137c0,-0 1.317,-34.034 16.029,-45.232c14.711,-11.198 49.64,-21.71 66.264,-43.736",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.461,273.262c-0,-0 -67.649,90.739 -86.925,134.319c-6.164,13.938 -129.155,66.276 -139.644,111.73c-0.804,3.484 56.43,55.519 179.849,41.584c49.854,-5.628 60.307,-10.8 78.533,-41.584c0,-0 -7.369,48.663 -176.365,23.626c-21.71,-3.216 -67.812,-15.546 -66.739,-26.267c1.072,-10.721 7.361,-26.024 119.336,-103.875",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.411,75.204c-0,-0 21.1,-1.859 26.833,10.676c5.733,12.535 11.523,26.475 12.872,28.33c1.349,1.855 10.603,13.584 12.833,22.505c2.23,8.92 18.183,76.678 21.271,77.879c-0,-0 36.656,-15.998 48.546,-27.366c2.058,-1.968 15.781,21.534 21.614,52.582c5.832,31.049 -94.86,92.261 -42.604,240.721c-0,-0 -16.691,-4.077 -19.546,-8.248c-2.854,-4.172 9.476,82.599 28.573,117.778c0,0 -6.7,3.016 -21.777,-2.68c-0,-0 1.34,11.056 7.371,21.777c-0,0 -4.021,1.006 -9.716,-2.345c-0,0 -52.855,-45.55 -110.873,-37.849c-47.329,6.282 -90.78,-16.752 -103.867,-34.027c-0,-0 -0.03,13.755 3.572,18.215c0,0 -38.617,-34.664 -57.265,-71.959c-0.857,-1.716 -4.46,-4.117 -13.551,2.916c-9.092,7.033 -27.104,23.844 -30.534,25.216c-3.431,1.373 -37.225,11.837 -40.141,4.117c-2.916,-7.719 0.172,-11.836 -1.544,-14.581c-1.715,-2.744 -7.719,1.887 -11.836,6.176c-4.117,4.288 -18.698,14.481 -22.472,14.274c-3.774,-0.208 -2.573,-11.873 -4.974,-14.274c-2.402,-2.402 -24.359,10.635 -40.312,10.635c-15.954,0 -39.455,0.172 -37.396,-6.518c2.058,-6.69 20.756,-22.3 34.308,-31.907c13.551,-9.606 36.366,-27.103 46.659,-31.392c10.292,-4.288 27.103,-20.07 79.251,-20.756c0,0 -2.744,-8.062 -5.489,-12.351c0,0 21.443,6.862 48.546,54.378c27.103,47.517 31.64,53.819 36.141,59.967c4.501,6.148 17.614,24.013 20.609,26.059",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.681,606.813c-0,0 43.668,127.29 10.51,194.717c0,-0 -3.423,-20.94 -8.448,-25.547c-0,-0 -13.402,103.163 -104.281,167.519c-0,0 105.537,-94.368 77.059,-235.503c-0,0 18.846,8.376 26.803,22.615c-0,0 7.241,-97.08 -36.399,-145.935",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.776,480.531c-0,-0 -11.921,-36.81 -19.984,-52.763c-8.062,-15.954 -20.413,-1.089 -27.275,8.804c0,0 9.193,-55.547 21.271,-78.793c25.045,-48.203 31.392,-60.382 45.458,-80.281c14.067,-19.898 16.983,-28.475 18.355,-33.278c1.373,-4.803 -2.948,-31.453 -4.986,-37.443",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.303,86.657c0,-0 12.781,5.852 15.855,18.412",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.158,105.069c0,-0 1.148,13.147 0.703,15.37c-0.351,1.756 -4.304,17.917 -6.148,19.234c0,0 9.486,10.1 10.979,23.363c1.493,13.262 2.102,78.491 6.493,89.47c4.392,10.978 3.157,17.154 11.528,16.879c8.371,-0.274 23.604,-4.391 34.994,-10.018c11.391,-5.626 43.777,-18.526 52.286,-53.795c-0,0 -0.549,-6.313 -2.745,-6.999c-2.196,-0.686 -12.9,5.215 -18.938,10.704c-6.038,5.49 -30.328,18.115 -33.759,18.664c-0,-0 -21.549,-83.581 -24.702,-88.927c-3.156,-5.352 -7.273,-20.859 -15.37,-25.662c-8.097,-4.803 -10.26,-5.828 -12.238,-7.132c-1.979,-1.304 -3.083,-1.151 -3.083,-1.151Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 609.198,
    cy: 122.371,
    r: 2.614,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "0.83px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.609,
    cy: 139.74,
    r: 2.614,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "0.83px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 631.008,
    cy: 120.235,
    r: 2.614,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "0.83px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWolf);
export default __webpack_public_path__ + "static/media/wolf.fd607a86.svg";
export { ForwardRef as ReactComponent };